import React from 'react';
import { fixMojibake } from '../../../../../utils/text/fix-mojibake';

export interface HeroImageProps {
  heroImage?: string | null;
  heroImageHasTransparency?: boolean;
  title?: string;
}

export const HeroImage: React.FC<HeroImageProps> = ({
  heroImage,
  heroImageHasTransparency = false,
  title,
}) => {
  if (!heroImage) {
    return null;
  }

  return (
    <div className={`-mx-2 md:-mx-8 -mt-8 mb-6 rounded-t-3xl overflow-hidden ${heroImageHasTransparency ? 'bg-white' : ''}`}>
      <img
        src={heroImage}
        alt={fixMojibake(title ?? '')}
        className="w-full h-auto max-h-96 object-cover"
        loading="lazy"
      />
    </div>
  );
};
